import { StringType } from "./strings";

const STRING_SQ: StringType = {
  translation: {
    general: {
      loading: "Duke ngarkuar...",
    },
    burgerMenu: {
      dutyPlan: "Plani i detyrave",
      dashboard: "Paneli",
      lights: "Dritat",
      jokeOfTheDay: "Shaka e ditës",
      settings: "Cilësimet",
      deliveryDriver: "Shoferi i shpërndarjes",
      wifi: "Wi-Fi",
      camera: "Kamera",
      images: "Fotot",
      scavengerhunt: "Fshesar",
    },
    dutyCard: {
      tasks: "Detyrat",
      tasksInDetail: "Detyrat në detaje",
      everyWeek: "Çdo javë",
      everyXWeeks_one: "Çdo {{count}} javë",
      everyXWeeks_other: "Çdo {{count}} javë",
      day_one: "{{count}} ditë",
      day_other: "{{count}} ditë",
    },
    trashCalendar: {
      title: "Kalendari i plehrave",
    },
    duties: {
      bathroom: {
        name: "Banjo",
        quote:
          "Kushdo që mban përgjegjësi për banjën, duhet të përballet me pasojat!",
        generalTasks: {
          bathroom: "Banjo",
          trash: "Plehrat",
        },
        detailedTasks: {
          cleanToilet: "Pastro tualetin",
          cleanSink: "Pastro lavamanin",
          cleanShower: "Pastro dushin",
          cleanFurniture: "Pastro mobiliet",
          disposeTrash: "Hidhi plehrat",
          disposeCompost: "Hidhi kompostin",
        },
      },
      floor: {
        name: "Dyshemeja",
        quote: "Dyshemeja na mban përjetësisht!",
        generalTasks: {
          livingRoom: "Dhoma e ndenjes",
          floor: "Dysheme",
          glasAndCans: "Qelqet dhe kanaçet",
        },
        detailedTasks: {
          cleanSofa: "Pastro divanin",
          lamps: "Dritat",
          vacuumClean: "Fshij me fshesë korenti",
          wipeFloor: "Laj dyshemenë",
          disposeGlasAndCans: "Hidhi qelqet dhe kanaçet",
          waterPlants: "Uji bimët",
        },
      },
      kitchen: {
        name: "Kuzhina",
        quote: "Pa një El Tony, as më të mirët nuk mund të bëjnë gjë!",
        generalTasks: {
          kitchen: "Kuzhina",
          petAndPlasticBottles: "Shishet e PET-it dhe plastikes",
          cardboardAndPaper: "Kartoni dhe letra",
        },
        detailedTasks: {
          cleanStoveTableAndSink: "Pastro sobën, tryezën dhe lavamanin",
          cleanSurfaces: "Pastro sipërfaqet",
          cleanTrashCabinet: "Pastro dollapin e plehrave",
          cleanSteamExhaust: "Pastro aspiratorin",
          disposeCardboardAndPaper: "Hidhi kartonin dhe letrat",
          disposePetAndPlasticBottles: "Hidhi shishet e PET-it dhe plastikes",
        },
      },
    },
    weatherCodes: {
      sunny: "Me diell",
      clear: "I kthjellët",
      mainlySunny: "Kryesisht me diell",
      mainlyClear: "Kryesisht i kthjellët",
      partlyCloudy: "Pjesërisht i vranët",
      cloudy: "I vranët",
      foggy: "Me mjegull",
      rimeFog: "Mjegull e ngrirë",
      lightDrizzle: "Pikim i lehtë",
      drizzle: "Pikim",
      heavyDrizzle: "Pikim i fortë",
      lightFreezingDrizzle: "Pikim i lehtë ngrirës",
      freezingDrizzle: "Pikim ngrirës",
      lightRain: "Shi i lehtë",
      rain: "Shi",
      heavyRain: "Shi i fortë",
      lightFreezingRain: "Shi i lehtë ngrirës",
      freezingRain: "Shi ngrirës",
      lightSnow: "Borë e lehtë",
      snow: "Borë",
      heavySnow: "Borë e fortë",
      snowGrains: "Kokrriza bore",
      lightShowers: "Rreshje të lehta",
      showers: "Rreshje",
      heavyShowers: "Rreshje të forta",
      lightSnowShowers: "Rreshje të lehta bore",
      snowShowers: "Rreshje bore",
      thunderstorm: "Stuhi me bubullima",
      lightThunderstormsWithHail: "Stuhi e lehtë me breshër",
      thunderstormWithHail: "Stuhi me breshër",
    },
    deliveryDrivers: {
      orderedOn: "Porositur më",
      order: "Porosia:",
    },
    camera: {
      done: "Gati!",
      imagePreviewInfoText: "Fotografia mund të shikohet në faqen e fotove",
    },
    settings: {
      language: "Gjuha",
      theme: "Tema",
      reload: "Rifresko faqen e internetit",
    },
  },
};

export default STRING_SQ;
